// src/components/DoubleBox1.js
import React from 'react';
import './DoubleBox.css'; 
import { FaMapMarkerAlt } from 'react-icons/fa'; 

const DoubleBox1 = () => {
  return (
    <div className="half-width-box">
      <div className="box-content">
        
        {/* Icon Section */}
        <div className="icon-section">
          <div className="icon-background">
            <FaMapMarkerAlt className="location-icon" />
          </div>
        </div>

        {/* Text Section */}
        <div className="text-section">
          <h2 className="box-title">Where is the event taking place?</h2>
          <p>The event will be held at IAV Hassan II, Rabat, Morocco.</p>
        </div>

      </div>
    </div>
  );
};

export default DoubleBox1;